// 用户协议
export const USER_PROTOCOL_URL = 'https://www.herogame.com/account/purchase.html'

// 隐私协议
export const PRIVACY_URL = 'https://www.herogame.com/account/PrivacyPolicytw.html'

export const GAME_FORM_DATA = 'GAME_FORM_DATA'

// 服务说明
export const SUB_SERVER_DESC = 'https://www.yingxiong.com/p/ocsc_hero.html'

export const EMAIL_REG = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
